export const ALL_ID = 'all';

export enum FilterTags {
  Category = 'FILTER:CATEGORY',
  Skills = 'FILTER:SKILLS',
  Custom = 'FILTER:CUSTOM',
  Level = 'FILTER:AUTO_LEVEL',
  LevelCustom = 'FILTER:CUSTOM_LEVEL',
}
